let translate = function( enText, cnText ) {

	if ( window.userLanguage === 'EN' && enText ) return enText;

	else return cnText;
};

exports.translate = translate;


// WEBPACK FOOTER //
// ./src/app/utils/translations.js